<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Candidatos</v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar..."
        single-line
        hide-details
      ></v-text-field>
      <v-dialog v-model="dialog" max-width="800px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo candidato</v-btn>
          <v-btn color="secundary" dark class="mb-2 teal darken-1" v-on:click="download">Descargar</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.name" label="Nombre" onkeyup="this.value = this.value.toUpperCase()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.email" label="E-mail"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.age" label="Edad"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.phone" label="Teléfono"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="editedItem.school"
                    :items="shools"
                    menu-props="auto"
                    label="Escolaridad"
                    hide-details
                    single-line
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.address" label="Ubicación"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.claim" type="number" label="Pretensiones"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.profile" label="Perfil" onkeyup="this.value = this.value.toUpperCase()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.status" label="Estatus" onkeyup="this.value = this.value.toUpperCase()"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.number }}</td>
        <td>{{ props.item.name }}</td>
        <td>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <i @click="gmail(props.item.name, props.item.email)" class="v-icon mr-2 v-icon--link theme--light far fa-envelope-open" style="font-size: 16px;cursor:pointer" v-on="on"></i> 
            </template>
            <span>{{ props.item.email }}</span>
          </v-tooltip>
        </td>
        <td>{{ props.item.age }}</td>
        <td><i @click="whatsapp(props.item.name, props.item.phone)" class="v-icon mr-2 v-icon--link theme--light fab fa-whatsapp" style="font-size: 16px;cursor:pointer"></i> {{ props.item.phone.replace(/[^0-9.]/g, "") }}</td>
        <td>{{ props.item.school }}</td>
        <td>{{ props.item.address }}</td>
        <td>{{ formatPrice(props.item.claim) }}</td>
        <td>{{ props.item.profile }}</td>
        <td>{{ props.item.status }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            class="mr-2"
            @click="deleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Recargar</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import firebase from '../Firebase'
  export default {
    data: () => ({
      dialog: false,
      search:'',
      headers: [
        { text: 'Id', value: 'number', sortable: true },
        {
          text: 'Nombre',
          value: 'name'
        },
        { text: 'E-mail', value: 'email' },
        { text: 'Edad', value: 'age' },
        { text: 'Teléfono', value: 'phone' },
        { text: 'Escolaridad', value: 'school' },
        { text: 'Ubicación', value: 'address' },
        { text: 'Pretensiones', value: 'claim' },
        { text: 'Perfil', value: 'profile' },
        { text: 'Estatus', value: 'status' },
        { text: 'Acciones', value: 'name', sortable: false }
      ],
      shools:[
        { text: 'TRUNCO' },
         { text: 'BACHILLERATO' },
         { text: 'LICENCIATURA' },
         { text: 'INGENIERÍA' },
         { text: 'MAESTRÍA' },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        id:'',
        number:0,
        name: '',
        email: '',
        age: 0,
        phone:'55',
        school: '',
        address: '',
        claim: 0,
        profile: '',
        status: ''
      },
      defaultItem: {
        id:'',
        number: 0,
        name: '',
        email: '',
        phone:'55',
        age: 0,
        school: '',
        address: '',
        claim: 0,
        profile: '',
        status: ''
      },
      Datas: {
      // We will make a Workbook contains 2 Worksheets
      'animals': [
                  {"name": "cat", "category": "animal"}
                  ,{"name": "dog", "category": "animal"}
                  ,{"name": "pig", "category": "animal"}
                ],
      'pokemons': [
                  {"name": "pikachu", "category": "pokemon"}
                  ,{"name": "Arbok", "category": "pokemon"}
                  ,{"name": "Eevee", "category": "pokemon"}
                ]
      },
      ref: firebase.firestore().collection('candidatos'),
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar nuevo candidato' : 'Editar candidato'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      // this.initialize()
      this.desserts = [];
      this.ref.get().then((querySnapshot) =>{
        let i = 0;
        querySnapshot.forEach( (doc) =>{
          console.log("DATO:", doc.id, doc.data().nombre, i);
          this.desserts.push({
            id: doc.id,
            number: i+1,
            name: doc.data().name.toUpperCase(),
            email: doc.data().email,
            age: doc.data().age,
            phone: doc.data().phone,
            school: doc.data().school.toUpperCase(),
            address: doc.data().address.toUpperCase(),
            claim: doc.data().claim,
            profile: doc.data().profile.toUpperCase(),
            status: doc.data().status?doc.data().status.toUpperCase():''
         });
         i++;
        })
      });

      console.log("Creado", this.desserts)
    },

    methods: {
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      initialize(){
        this.desserts = [];
        this.ref.get().then((querySnapshot) =>{
          querySnapshot.forEach( (doc, i) =>{
            console.log("DATO:", doc.id, doc.data().nombre);
            this.desserts.push({
              id: doc.id,
              number: i+1,
              name: doc.data().name.toUpperCase(),
              age: doc.data().age,
              email: doc.data().email,
              school: doc.data().school.toUpperCase(),
              address: doc.data().address.toUpperCase(),
              claim: doc.data().claim,
              profile: doc.data().profile.toUpperCase(),
              status: doc.data().status.toUpperCase()
          });
          })
        });
      },

      whatsapp (name, phone) {
        var msg = "HOLA, BUENAS TARDES " + name
        var urlRef = 'https://wa.me/521' + phone + '?text='+ encodeURIComponent(msg)
        window.open(urlRef,'_blank');
      },

      gmail (name, email) {
        var msg = "Hola " + name
        var asunto = "OFERTA LABORAL "
        // https://mail.google.com/mail/?view=cm&fs=1&to=email@domain.com
        // https://mail.google.com/mail/?view=cm&ui=2&tf=0&fs=1&to=&su=Subject&body=Body
        var urlRef = 'https://mail.google.com/mail/?view=cm&ui=2&tf=0&fs=1&to=' + email +'&su=' + asunto + '&body=' + msg
        window.open(urlRef,'_blank');
      },

      editItem (item) {
        console.log("Editando...", item)
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        console.log("ITEME:", this.editedItem)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.desserts.indexOf(item)
        var result = confirm('Desea eliminar el candidato?') && this.desserts.splice(index, 1)

        if (result) {
           firebase.firestore().collection('candidatos').doc(item.id).delete().then(() => {
           console.log("Eliminado");
           this.$notify({
              group: 'foo',
              title: 'Eliminación exitosa',
              text: 'Candidato eliminado'
            });
          }).catch((error) => {
            alert("Error removing document: ", error);
            this.$notify({
              group: 'foo',
              title: 'Hubo un error inesperado',
              text: 'Algo salió mal',
              type: 'error'
            });
          });
        }

        
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          
          console.log("ID editar:", this.editedItem.id)
          var idEdit = this.editedItem.id;

          this.ref.doc(idEdit).update(this.editedItem).then((docRef) => {
            console.log("Actualizado");
            this.$notify({
              group: 'foo',
              title: 'Actualización exitosa',
              text: 'Candidato modificado'
            });
          })
          .catch((error) => {
            console.error("Error al editar:", error);
            this.$notify({
              group: 'foo',
              title: 'Hubo un error inesperado',
              text: 'Algo salió mal',
              type: 'error'
            });
          });
          Object.assign(this.desserts[this.editedIndex], this.editedItem)

        } else {
          this.desserts.push(this.editedItem);
          this.ref.add(this.editedItem).then((docRef) => {
            console.log("Añadido", docRef.id);
            this.$notify({
              group: 'foo',
              title: 'Creación exitosa',
              text: 'Candidato agregado',
              type: 'success'
            });
            this.initialize()
          })
          .catch((error) => {
            alert("Error adding document: ", error);
            this.$notify({
              group: 'foo',
              title: 'Hubo un error inesperado',
              text: 'Algo salió mal',
              type: 'error'
            });
          });
        }
        this.close()
      },
      download(){
        // export json to Worksheet of Excel
        // only array possible
        var candidatosWS = XLSX.utils.json_to_sheet(this.desserts)

        // A workbook is the name given to an Excel file
        var wb = XLSX.utils.book_new() // make Workbook of Excel

        // add Worksheet to Workbook
        // Workbook contains one or more worksheets
        XLSX.utils.book_append_sheet(wb, candidatosWS, 'Candidatos') // sheetAName is name of Worksheet

        // export Excel file
        XLSX.writeFile(wb, 'candidatos.xlsx') // name of the file is 'book.xlsx'
      }
    }
  }
</script>
<style>

</style>
